import { gql } from '@apollo/client';

export const GET_SH_DASHBOARD = gql`
  query GetShDashboard {
    MDB {
      id
      _SH_ {
        id
        Dashboard {
          structures {
            total
          }
          fields {
            total
            byType {
              type
              total
            }
          }
          reservations {
            total
            today
            upcoming
            created
            pending
            confirmed
            cancelled
            completed
            paid
          }
          matches {
            total
            active
            completed
            cancelled
          }
        }
      }
    }
  }
`;
